import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-screen h-screen flex items-center justify-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/LogoIcon.svg",
  class: "animate-loading-spin w-20"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "mb-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_ctx.load && (_ctx.$route.name != 'auth' || undefined))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        (_ctx.$route.name != 'auth')
          ? (_openBlock(), _createBlock(_component_Header, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_Notification),
        _createVNode(_component_RouterView)
      ]))
}